module.exports = __webpack_public_path__ + "img/cloud2.6ef7411a.svg";